import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { EntryWayLayout, Text } from 'app/components';
import getPathByName from 'app/core/Navigation/getPathByName';

import { useI18n } from 'i18n';

import SignUpForm from './SignUpForm';
import useSignUp from './useSignUp';

export default function SignUpPage() {
    const { t } = useI18n();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email') ?? '';
    const inviteKey = searchParams.get('inviteKey') ?? '';

    const signUp = useSignUp();

    return (
        <>
            <Helmet>
                <title>{t('signup_page.meta_title')}</title>
                <meta name="description" content={t('signup_page.meta_description')} />
            </Helmet>

            <EntryWayLayout title={t('signup_page.page_title')} message={t('signup_page.form_prompt')}>
                <SignUpForm
                    email={email}
                    inviteKey={inviteKey}
                    errorMessage={signUp.errorMessage}
                    onSubmit={signUp.run}
                    mb={7}
                />

                <Box display="flex" justifyContent="center">
                    <Text
                        variant="detail"
                        as="p"
                        color="secondary"
                        renderLink={({ text }) => (
                            <Link component={RouterLink} to={getPathByName('SIGN_IN')}>
                                {text}
                            </Link>
                        )}
                    >
                        {t('signup_page.sign_in_message')}
                    </Text>
                </Box>
            </EntryWayLayout>
        </>
    );
}
